import { module } from 'modujs';
import gsap from "gsap";

export default class extends module {
    constructor(m) {
        super(m);

        this.backgroundsWrap = this.el.querySelector('.o-home-hero_backgrounds');
        this.items = [...this.el.querySelectorAll('.o-home-hero_backgrounds_item')];
        this.navItems = [...this.el.querySelectorAll('.o-home-hero_nav_item')];

        this.currentIndex = 0;
        this.maxIndex = this.items.length - 1;
        this.currentZIndex = 1;

        this.progressAnim = gsap.timeline({ delay: 4, repeatDelay: 4, repeat: -1});
        this.progressAnim.call(() => { this.playProgress(); });
        
        this.events = {
            click: {
                activateItem: 'activateItem'
            }
        }
    }

    playProgress() {
        let newIndex = this.currentIndex == this.maxIndex ? 0 : this.currentIndex + 1;
        this.showItem(newIndex);
    }

    animate(e) {
        if (e.way == 'leave' && e.from == 'start') {
            this.el.classList.remove('-animated');
            this.call('setStyle', 'home-hero-1', 'Shape');
            // if (this.progressAnim) {
            //     this.progressAnim.pause();
            // }
        } else {
            this.el.classList.add('-animated');
            this.call('setStyle', 'home-hero-2', 'Shape');
            // if (this.progressAnim && !this.progressAnim.isActive()) {
            //     this.progressAnim.play();
            // }
        }
    }

    showItem(index) {
        // If current is already active
        if (this.currentIndex == index) {
            return;
        }

        let oldItem = this.items[this.currentIndex];
        let oldNavItem = this.navItems[this.currentIndex];

        if (oldItem) {
            oldItem.classList.remove('-active');
            this.pauseMedia(oldItem);
        }
        if (oldNavItem) {
            oldNavItem.classList.remove('-active');
        }

        this.currentIndex = index;
        this.currentZIndex = this.currentZIndex + 1;

        let newItem = this.items[this.currentIndex];
        let newNavItem = this.navItems[this.currentIndex];
        
        newItem.style.zIndex = this.currentZIndex;
        newItem.classList.add('-active');
        newNavItem.classList.add('-active');

        this.playMedia(newItem);
    }

    playMedia(mediaWrap) {
        if (mediaWrap.querySelector('video')) {
            mediaWrap.querySelector('video').play();
        }
    }

    pauseMedia(mediaWrap) {
        if (mediaWrap.querySelector('video')) {
            mediaWrap.querySelector('video').pause();
        }
    }

    activateItem(e) {
        let target = e.currentTarget;
        let index = parseInt(target.getAttribute("data-index"));
        
        if (index == this.currentIndex) return;

        this.progressAnim.pause();
        this.showItem(index);
    }

    toggle(e){
        if (e.way == 'leave') {
            if (this.progressAnim) {
                this.progressAnim.pause();
                this.pauseMedia(this.items[this.currentIndex]);
            }
        }
    }

}
